import { useState, useContext, useEffect, useRef } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Dialog from '../components/dialog.jsx';
import VideoCard from '../components/video-card.js';
import ImageCard from '../components/image-card.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LinkCard from '../components/link-card.js';
import {  faRepeat, faImage, faPlusCircle, faGlobe, faDownload, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import FileDragDrop from '../components/drag-drop.jsx';
import { SortableContainer } from '../components/sortable.jsx';
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

const ModulePosition = ({ position, setPositions, index }) => {
    const inc = () => {
        if (position == 6)
            return;
        setPositions(_p => {
            let p = [..._p];
            let i = p.findIndex(a => a === position + 1);
            p[i]--;
            p[index]++;
            return p;
        })
    }
    const dec = () => {
        if (position == 1)
            return;
        setPositions(_p => {
            let p = [..._p];
            let i = p.findIndex(a => a === position - 1);
            p[i]++;
            p[index]--;
            return p;
        })
    }
    return (
        <div className="module-order">
            <button onClick={dec} disabled={position == 1}>{'\u25C0'}</button>
            <div>{position}</div>
            <button onClick={inc} disabled={position == 5}>{'\u25B6'}</button>
        </div>
    )
}
const Host = () => {
    const navigate = useNavigate();
    const { role, metaData, podcastId } = useContext(AccessContext);
    const isHost = role == 'Host/Guest';
    var _sid = undefined;
    if (isHost)
        _sid = metaData.speakerId;
    else
        _sid = podcastId;
    const location = useLocation();
    const addVideoRef = useRef(null);
    const addImageRef = useRef(null);
    const cropperRef = useRef(null);
    const cropImageRef = useRef(null);
    const linkRef = useRef(null);
    const [videoUrl, setVideoUrl] = useState('');
    const [toAddImagesTitle, setToAddImagesTitle] = useState('');
    const [toAddVideoTitle, setToAddVideoTitle] = useState('');
    const [imageFiles, setImageFiles] = useState([]);
    const [crop, setCrop] = useState();
    const [pixelCrop, setPixelCrop] = useState();
    const [id, setId] = useState(_sid);
    const setContext = useContext(Context)[1];
    useEffect(() => {
        setId(id || location.state?.id || _sid);
    }, [_sid]);
    if (isHost)
        setContext('Edit Host/Guest');
    else
        setContext('Edit Podcast');
    const defaultHost = {
        imageUrl: '',
        firstName: '',
        lastName: '',
        description: '',
        createdDate: '',
        createdBy: '',
        updatedDate: '',
        updatedBy: '',
        isHost: 'true',
        isGuest: 'true',
        events: [],
        socials: [],
        merch: [],
        episodes: [],
        images: [],
        videos: [],
        links: [],
        metaData: {}
    }
    const [host, setHost] = useState(defaultHost);
    const [positions, setPositions] = useState([1, 2, 3, 4, 5, 6]);
    const [loading, setLoading] = useState(id ? true : false);
    const [file, setFile] = useState(null);
    const [deleteImage, setDeleteImage] = useState(false);
    const [isDownload, setIsDownload] = useState(false);
    const [linkAddSection, setLinkAddSection] = useState(0);
    const [newLinkText, setNewLinkText] = useState('');
    const [newLinkURL, setNewLinkURL] = useState('');
    const [downloadFile, setDownloadFile] = useState([]);
    const [downloadFP, setDownloadFP] = useState('');
    const [videoContainerWidth, setVideoContainerWidth] = useState('100%');
    const [linkType, setLinkType] = useState(0);

    function getVideoDetails(url) {
        const isYouTubeShort = url.includes('youtube.com/shorts/');
        const isTikTok = url.includes('tiktok.com');
        
        // Enhanced YouTube ID Regex to include shorts path
        const ytRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
        const match = url.match(ytRegExp);
        const videoId = match && match[2].length === 11 ? match[2] : null;

        return {
            videoId,
            isVertical: isYouTubeShort || isTikTok,
            isTikTok,
            isYouTube: !!videoId
        };
    }
    const getStandardVideos = () => {
        if (!host?.videos?.length)
            return [];
        var videos = [];
        for (var i = 0; i < host.videos.length; i++) {
            let video = host.videos[i];
            let details = getVideoDetails(video.videoUrl);
            if (!details.isVertical)
                videos.push(video);
        }
        return videos;
    }
    const getShorts = () => {
        if (!host?.videos?.length)
            return [];
        var videos = [];
        for (var i = 0; i < host.videos.length; i++) {
            let video = host.videos[i];
            let details = getVideoDetails(video.videoUrl);
            if (details.isVertical)
                videos.push(video);
        }
        return videos;
    }
    const videoDialogClose = () => {
        setVideoUrl('');
        setToAddVideoTitle('');
    }
    const imageDialogClose = () => {
        setImageFiles([]);
        setToAddImagesTitle('');
        setPixelCrop();
        setCrop();
    }
    function fillArrayUpToN(arr, n) {
        const TARGET_NUMBER = n;

        if (arr.length < TARGET_NUMBER) {
            const startNum = arr.length + 1;
            for (let i = startNum; i <= TARGET_NUMBER; i++) {
                arr.push(i);
            }
        }

        return arr;
    }
    const loadHost = () => {
        axios.post(process.env.REACT_APP_API_URL + (isHost ? 'host' : 'podcast'), {
            id: id
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                if (r.data.results.moduleOrder)
                    setPositions(fillArrayUpToN(r.data.results.moduleOrder.split(',').map(n => parseInt(n)), 6));
                r.data.results.socials = r.data.results.socials || [];
                r.data.results.videos = r.data.results.videos || [];
                r.data.results.images = r.data.results.images || [];
                setHost(r.data.results);
            }
        });
    }
    useEffect(() => {
        if (id) {
            loadHost();
        } else {
            setLoading(false);
        }
    }, [id]);
    const save = () => {
        if (isHost)
            saveHost();
        else
            savePodcast();
    }
    const savePodcast = () => {
        
        axios.post(process.env.REACT_APP_API_URL + 'podcast/media/save', {
            images: JSON.stringify((host.images || []).map(h => h.id)),
            videos: JSON.stringify(host.videos),
            links: JSON.stringify((host.links || []).map(l => ({text: l.text, url: l.url, isDownload: l.isDownload ? 1 : 0, type: l.type})))
        }).then(r => {
            if (r?.data?.status === 'Success') {
                toast.success('Saved');
                setFile(null);
                setDeleteImage(false);
                setLoading(true);
                loadHost();
            }
        });
    }
    const saveHost = () => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('firstName', host.firstName);
        formData.append('lastName', host.lastName);
        formData.append('description', host.description);
        formData.append('imgUrl', host.imageUrl);
        formData.append('moduleOrder', positions.join(','));
        formData.append('isGuest', host.isGuest || '');
        formData.append('isHost', host.isHost || '');
        formData.append('events', JSON.stringify((host.events || []).map(a => a.id)));
        formData.append('videos', JSON.stringify(host.videos));
        formData.append('images', JSON.stringify((host.images || []).map(h => h.id)));
        formData.append('merch', JSON.stringify((host.merch || []).map(a => a.id)));
        formData.append('socials', JSON.stringify(host.socials || []));
        formData.append('links', JSON.stringify((host.links || []).map(l => ({text: l.text, url: l.url, isDownload: l.isDownload ? 1 : 0, type: l.type}))));
        formData.append('metaData', JSON.stringify(host.metaData || {}));
        formData.append('deleteImage', deleteImage);
        
        formData.append('id', id);
        axios.post(process.env.REACT_APP_API_URL + 'speaker/update', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(r => {
            if (r?.data?.status === 'Success') {
                toast.success('Saved');
                setFile(null);
                setDeleteImage(false);
                setLoading(true);
                loadHost();
            }
        });
    }
    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    const getMaxId = (arr) => {
        if (arr.length === 0) return 0;
        return Math.max(...arr.map(item => item.id));
    };
    return (
        <main>
            {/*<Dialog ref={addVideoRef} onClose={videoDialogClose} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addVideoRef.current.hide();
                        videoDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={videoUrl == ''} onClick={() => {
                        addVideoRef.current.hide();
                        if (videoUrl == '')
                            return;
                        var vid = host.videos.find(v => v.videoUrl.toLowerCase() == videoUrl.toLowerCase());
                        if (vid) {
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return;
                        }
                        setHost(_e => {
                            let e = { ..._e };
                            e.videos = e.videos || [];
                            e.videos.push({ videoUrl: videoUrl, title: toAddVideoTitle, id: getMaxId(e.videos) + 1 });
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return e;
                        });
                    }}>Save Video</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, maxWidth: 400 }} className="w-100 p-rel">
                    <label className="mb-25" style={{display: 'block'}}>Add Video</label>
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row mb-10 flex f-wrap">
                        <label style={{marginBottom: -5}} htmlFor="find-video" className="w-100 text-sm">Video URL</label>
                        <input type="text" id="find-video" className="w-50" placeholder="Video URL" style={{flexGrow: 1}} value={videoUrl} onChange={e => setVideoUrl(e.target.value)} />
                        <label style={{marginBottom: -5}} className="mt-15 w-100 text-sm">Video Title (Optional)</label>
                        <input type="text" placeholder="Video Title" value={toAddVideoTitle} className="w-100" aria-label="Video Title" onChange={(e) => setToAddVideoTitle(e.target.value)} />
                        <label style={{marginBottom: -5}} className="w-100 mt-15 text-sm">Video Preview</label>
                        {!!videoUrl ? <div className="preview-container mt-0"><VideoCard video={{
                            videoUrl: videoUrl, title: toAddVideoTitle
                        }} /></div> : (
                            <div className="no-video-preview w-100 mt-0">
                                <FontAwesomeIcon icon={faYoutube} style={{fontSize: 64}} />
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={addImageRef} onClose={imageDialogClose} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addImageRef.current.hide();
                        imageDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={imageFiles.length == 0 || !imageFiles[0].file || !imageFiles[0].thumbnail} onClick={() => {
                        if (imageFiles.length == 0 || !imageFiles[0].file)
                            return;
                        if (!imageFiles[0].thumbnail) {
                            toast.error('Create a thumbnail to continue');
                            return;
                        }
                        var formData = new FormData();
                        formData.append('image', imageFiles[0].file);
                        formData.append('thumbnail', imageFiles[0].thumbnail);
                        formData.append('title', toAddImagesTitle);
                        
                        axios.post(process.env.REACT_APP_API_URL + 'image/add', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(r => {
                            if (r?.data?.status === 'Success') {
                                axios.post(process.env.REACT_APP_API_URL + 'image', {id: r.data.id})
                                    .then(_r => {
                                        if (_r?.data?.status === 'Success') {
                                            toast.success('Image Added');
                                            setHost(_e => {
                                                let e = { ..._e };
                                                e.images = e.images || [];
                                                e.images.push({
                                                    id: _r.data.results.id,
                                                    imageUrl: _r.data.results.imageUrl,
                                                    thumbnailUrl: _r.data.results.thumbnailUrl,
                                                    title: _r.data.results.title
                                                });
                                                return e;
                                            });
                                        }
                                        imageDialogClose();
                                        addImageRef.current.hide();
                                    });
                            }
                        });
                    }}>Add Image</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <label htmlFor="image-file" style={{display: 'block'}} className="mb-20">Add Image</label>
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        {!imageFiles || imageFiles.length == 0 ? (<FileDragDrop files={imageFiles} setFiles={setImageFiles}
                        accept='image/png,image/jpg,image/jpeg' acceptText="JPEG, JPG, PNG" />) :
                        (
                            <div className="w-100 gap-10 f-col f-start flex f-wrap">
                                <label style={{marginBottom: -5}} className="text-sm">Image Title (Optional)</label>
                                <input type="text" placeholder="Image Title" value={toAddImagesTitle} className="w-100" aria-label="Image Title" onChange={(e) => setToAddImagesTitle(e.target.value)} />
                                <div className="flex gap-20 a-start w-100">
                                    <div className="flex gap-10 f-col w-60 f-start">
                                        <label className='mt-10 text-sm'>Image Preview</label>
                                        <div style={{width: '100%'}}>
                                            <img src={imageFiles[0].previewUrl} alt={toAddImagesTitle} />
                                            {!!toAddImagesTitle && (<div className="image-title">
                                                {toAddImagesTitle}
                                            </div>)}
                                        </div>
                                    </div>
                                    <div className="flex gap-10 f-col f-start w-40" style={{alignSelf: 'stretch'}}>
                                        <label className='mt-10 text-sm'>Thumbnail (required)</label>
                                        {!imageFiles[0].thumbnailUrl ? (
                                            <div
                                                role="button"
                                                onClick={() => {
                                                    cropperRef.current.show();
                                                }}
                                                className={`border-2 border-dashed rounded p-30 cursor-pointer transition-shadow`}
                                                style={{ borderColor: 'rgba(156,163,175,0.6)', width: '100%', height: '100%' }}
                                                >
                                                <div className="text-center gap-5 flex f-col f-center a-center" style={{height: '100%', width: '100%'}}>
                                                    <FontAwesomeIcon icon={faImage} style={{fontSize: 48}} />
                                                    <div style={{textDecoration: 'underline'}} className="mt-5 font-bold">Create<br />Tumbnail</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <img onClick={() => cropperRef.current.show()} style={{cursor: 'pointer'}} src={imageFiles[0].thumbnailUrl} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={cropperRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        cropperRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={!pixelCrop} onClick={() => {
                        if (!pixelCrop) {
                            toast.error('Please make a crop.')
                        }
                        var cropCanvas = document.createElement('canvas');
                        var scale = cropImageRef.current.naturalWidth / cropImageRef.current.width;
                        cropCanvas.width = pixelCrop.width * scale;
                        cropCanvas.height = pixelCrop.height * scale;
                        var ctx = cropCanvas.getContext('2d');
                        ctx.drawImage(
                            cropImageRef.current,
                            pixelCrop.x * scale,
                            pixelCrop.y * scale,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale,
                            0,
                            0,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale
                        );
                        cropCanvas.toBlob((b) => {
                            setImageFiles(i => {
                                var newI = [...i];
                                newI[0].thumbnail = b;
                                newI[0].thumbnailUrl = cropCanvas.toDataURL();
                                return newI;
                            });
                            cropperRef.current.hide();
                        });
                    }}>Add Thumbnail</button>
                </div>
            )}>
                {imageFiles?.length > 0 && (
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => {
                            setCrop(percentCrop);
                        }}
                        onComplete={(c) => {
                            setPixelCrop(c);
                        }}
                        aspect={1}
                        minHeight={1}
                        >
                        <img ref={cropImageRef}
                            alt="Crop me"
                            style={{width: 400, maxWidth: '80vw'}}
                            src={imageFiles[0].previewUrl}
                        />
                    </ReactCrop>
                )}
            </Dialog>
            <Dialog ref={linkRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        setNewLinkText('');
                        setNewLinkURL('');
                        setIsDownload(false);
                        setLinkAddSection(0);
                        linkRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={linkAddSection == 0} onClick={async () => {
                        if (newLinkText == '' || (newLinkURL == '' && (!downloadFile || downloadFile?.length == 0)))
                            return;
                        var link = host?.links?.find?.(v => v.url.toLowerCase() == newLinkURL.toLowerCase() && v.text.toLowerCase() == newLinkText.toLowerCase());
                        if (link) {
                            setNewLinkText('');
                            setNewLinkURL('');
                            setIsDownload(false);
                            setLinkAddSection(0);
                            return;
                        }
                        var _newLinkUrl = newLinkURL;
                        if (isDownload) {
                            const formData = new FormData();
                            formData.append('file', downloadFile);
                            const data = await axios.post(process.env.REACT_APP_API_URL + 'file/upload', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                            if (data.data.status != 'Success') {
                                toast.error('Failed to upload file.');
                                return;
                            }
                            _newLinkUrl = data.data.url;
                        }
                        setHost(_e => {
                            let e = { ..._e };
                            e.links = e.links || [];
                            e.links.push({ url: _newLinkUrl, text: newLinkText, isDownload: isDownload, id: getMaxId(e.links) + 1 });
                            setNewLinkText('');
                            setNewLinkURL('');
                            setIsDownload(false);
                            setLinkAddSection(0);
                            return e;
                        });
                        linkRef.current.hide();
                    }}>Add</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, height: 223 }} className="w-100">
                    <label className="mb-15" style={{display: 'block'}}>Add Link or Download</label>
                    {linkAddSection == 0 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-15 f-col">
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                style={{borderBottom: '1px solid'}}
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(false);
                                }}>
                                <span>
                                    Create Web Link
                                </span>
                                <FontAwesomeIcon icon={faGlobe} className="add-icon" />
                            </a>
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(true);
                                }}>
                                <span>
                                    Create Download
                                </span>
                                <FontAwesomeIcon icon={faDownload} className="add-icon" />
                            </a>
                        </div>
                    )}
                    {linkAddSection == 1 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-10 mt-35 f-row f-wrap">
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="w-100 text-sm">{isDownload ? "Download Title" : "Web Link Title"}</label>
                            <input id="link-text" type="text" className="w-100" value={newLinkText} onChange={(e) => setNewLinkText(e.target.value)} />
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="mt-20 w-100 text-sm">{isDownload ? "Upload File" : "Web Link URL"}</label>{isDownload ? (
                                <input type="file" className="grow" value={downloadFP} onChange={(e) => {
                                    setDownloadFP(e.target.value);
                                    setDownloadFile(e.target.files[0]);
                                }} />
                            ) : (
                                <input id="link-url" type={"text"} className="grow" value={newLinkURL} onChange={(e) => setNewLinkURL(e.target.value)} />
                            )}
                        </div>
                    )}
                </div>
            </Dialog>*/}

            <Dialog ref={addVideoRef} onClose={videoDialogClose} title="Add Video or Short" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addVideoRef.current.hide();
                        videoDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={videoUrl == ''} onClick={() => {
                        console.log("Adding Video Begin");
                        addVideoRef.current.hide();
                        if (videoUrl == '')
                            return;
                        console.log("Video URL Found");
                        var vid = host.videos.find(v => v.videoUrl.toLowerCase() == videoUrl.toLowerCase());
                        console.log("Searching For Existing Video");
                        if (vid) {
                            console.log("Existing Video Found");
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return;
                        }
                        console.log("Adding Video");
                        setHost(_e => {
                            let e = { ..._e };
                            e.videos = e.videos || [];
                            e.videos.push({ videoUrl: videoUrl, title: toAddVideoTitle, id: getMaxId(e.videos) + 1 });
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return e;
                        });
                    }}>Add Video</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, maxWidth: 400 }} className="w-100 p-rel">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row mb-10 flex f-wrap">
                        <label style={{marginBottom: -5}} htmlFor="find-video" className="w-100 text-sm">Video URL</label>
                        <input type="text" id="find-video" className="w-50" placeholder="Video URL" style={{flexGrow: 1}} value={videoUrl} onChange={e => {
                            setVideoUrl(e.target.value);
                            setVideoContainerWidth(e.target.value.toLowerCase().includes("shorts") || e.target.value.toLowerCase().includes("tiktok") ? 150 : '100%');
                        }} />
                        <label style={{marginBottom: -5}} className="mt-15 w-100 text-sm">Video Title (Optional)</label>
                        <input type="text" placeholder="Video Title" value={toAddVideoTitle} className="w-100" aria-label="Video Title" onChange={(e) => {
                            setToAddVideoTitle(e.target.value);
                        }} />
                        <label style={{marginBottom: -5}} className="w-100 mt-15 text-sm">Video Preview</label>
                        {!!videoUrl ? <div style={{width: videoContainerWidth}} className="preview-container mt-0"><VideoCard video={{
                            videoUrl: videoUrl, title: toAddVideoTitle
                        }} /></div> : (
                            <div className="no-video-preview w-100 mt-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <path d="M9.99902 5L33.3304 19.9987L9.99902 34.9975V5Z" stroke="#E5E7EB" stroke-width="3.33305" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={addImageRef} onClose={imageDialogClose} title="Add Image" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addImageRef.current.hide();
                        imageDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={imageFiles.length == 0 || !imageFiles[0].file || !imageFiles[0].thumbnail} onClick={() => {
                        if (imageFiles.length == 0 || !imageFiles[0].file)
                            return;
                        if (!imageFiles[0].thumbnail) {
                            toast.error('Create a thumbnail to continue');
                            return;
                        }
                        var formData = new FormData();
                        formData.append('image', imageFiles[0].file);
                        formData.append('thumbnail', imageFiles[0].thumbnail);
                        formData.append('title', toAddImagesTitle);
                        
                        axios.post(process.env.REACT_APP_API_URL + 'image/add', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(r => {
                            console.log(r);
                            if (r?.data?.status === 'Success') {
                                axios.post(process.env.REACT_APP_API_URL + 'image', {id: r.data.id})
                                    .then(_r => {
                                        if (_r?.data?.status === 'Success') {
                                            toast.success('Image Added');
                                            setHost(_e => {
                                                let e = { ..._e };
                                                e.images = e.images || [];
                                                e.images.push({
                                                    id: _r.data.results.id,
                                                    imageUrl: _r.data.results.imageUrl,
                                                    thumbnailUrl: _r.data.results.thumbnailUrl,
                                                    title: _r.data.results.title
                                                });
                                                return e;
                                            });
                                        }
                                        imageDialogClose();
                                        addImageRef.current.hide();
                                    });
                            }
                        });
                    }}>Add Image</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        {/*<input type="file" id="image-file" accept="image/*" style={{flexGrow: 1}} onChange={(e) => { setFile(e.target.files[0]); setFP(e.target.value) }} value={fp} />*/}
                        {!imageFiles || imageFiles.length == 0 ? (<FileDragDrop type="image" darkBackground files={imageFiles} setFiles={setImageFiles}
                        accept='image/png,image/jpg,image/jpeg,image/webp' acceptText="JPEG, JPG, PNG, WEBP" />) :
                        (
                            <div className="w-100 gap-10 f-col f-start flex f-wrap">
                                <label style={{marginBottom: -5}} className="text-sm">Image Title (Optional)</label>
                                <input type="text" placeholder="Image Title" value={toAddImagesTitle} className="w-100" aria-label="Image Title" onChange={(e) => setToAddImagesTitle(e.target.value)} />
                                <div className="flex gap-20 a-start w-100">
                                    <div className="flex gap-10 f-col w-60 f-start">
                                        <label className='mt-10 text-sm'>Image Preview</label>
                                        <div style={{width: '100%'}}>
                                            <img src={imageFiles[0].previewUrl} alt={toAddImagesTitle} />
                                            {!!toAddImagesTitle && (<div className="image-title">
                                                {toAddImagesTitle}
                                            </div>)}
                                        </div>
                                    </div>
                                    <div className="flex gap-10 f-col f-start w-40" style={{alignSelf: 'stretch'}}>
                                        <label className='mt-10 text-sm'>Thumbnail (required)</label>
                                        {!imageFiles[0].thumbnailUrl ? (
                                            <div
                                                role="button"
                                                onClick={() => {
                                                    cropperRef.current.show();
                                                }}
                                                className={`file-drop-container border-2 border-dashed rounded-lg p-30 cursor-pointer transition-shadow`}
                                                style={{ borderColor: 'rgba(156,163,175,0.6)', width: '100%', height: '100%', backgroundColor: '#F9FAFB' }}
                                                >
                                                <div className="text-center gap-5 flex f-col f-center a-center" style={{height: '100%', width: '100%', color: '#364153'}}>
                                                    <FontAwesomeIcon icon={faImage} style={{fontSize: 48}} />
                                                    <div style={{textDecoration: 'underline'}} className="mt-5 font-bold">Create<br />Tumbnail</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <img onClick={() => cropperRef.current.show()} style={{cursor: 'pointer'}} src={imageFiles[0].thumbnailUrl} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={cropperRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        cropperRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={!pixelCrop} onClick={() => {
                        if (!pixelCrop) {
                            toast.error('Please make a crop.')
                        }
                        var cropCanvas = document.createElement('canvas');
                        var scale = cropImageRef.current.naturalWidth / cropImageRef.current.width;
                        cropCanvas.width = pixelCrop.width * scale;
                        cropCanvas.height = pixelCrop.height * scale;
                        var ctx = cropCanvas.getContext('2d');
                        ctx.drawImage(
                            cropImageRef.current,
                            pixelCrop.x * scale,
                            pixelCrop.y * scale,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale,
                            0,
                            0,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale
                        );
                        cropCanvas.toBlob((b) => {
                            setImageFiles(i => {
                                var newI = [...i];
                                newI[0].thumbnail = b;
                                newI[0].thumbnailUrl = cropCanvas.toDataURL();
                                return newI;
                            });
                            cropperRef.current.hide();
                        });
                    }}>Add Thumbnail</button>
                </div>
            )}>
                {imageFiles?.length > 0 && (
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => {
                            setCrop(percentCrop);
                        }}
                        onComplete={(c) => {
                            setPixelCrop(c);
                        }}
                        aspect={1}
                        minHeight={1}
                        >
                        <img ref={cropImageRef}
                            alt="Crop me"
                            style={{width: 400, maxWidth: '80vw'}}
                            src={imageFiles[0].previewUrl}
                        />
                    </ReactCrop>
                )}
            </Dialog>
            <Dialog ref={linkRef} onClose={() => {
                setNewLinkText('');
                setNewLinkURL('');
                setIsDownload(false);
                setLinkAddSection(0);
                setLinkType(0);
            }} title="Add Link or Download" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        setNewLinkText('');
                        setNewLinkURL('');
                        setLinkType(0);
                        setIsDownload(false);
                        setLinkAddSection(0);
                        linkRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={linkAddSection == 0} onClick={async () => {
                        if (newLinkText == '' || (newLinkURL == '' && (!downloadFile || downloadFile?.length == 0)))
                            return;
                        var link = host?.links?.find?.(v => v.url.toLowerCase() == newLinkURL.toLowerCase() && v.text.toLowerCase() == newLinkText.toLowerCase());
                        if (link) {
                            setNewLinkText('');
                            setNewLinkURL('');
                            setLinkType(0);
                            setIsDownload(false);
                            setLinkAddSection(0);
                            linkRef.current.hide();
                            return;
                        }
                        var _newLinkUrl = newLinkURL;
                        if (isDownload) {
                            const formData = new FormData();
                            formData.append('file', downloadFile);
                            const data = await axios.post(process.env.REACT_APP_API_URL + 'file/upload', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                            if (data.data.status != 'Success') {
                                toast.error('Failed to upload file.');
                                return;
                            }
                            _newLinkUrl = data.data.url;
                        }
                        setHost(_e => {
                            let e = { ..._e };
                            e.links = e.links || [];
                            e.links.push({ url: _newLinkUrl, text: newLinkText, isDownload: isDownload, type: linkType, id: getMaxId(e.links) + 1 });
                            setNewLinkText('');
                            setNewLinkURL('');
                            setLinkType(0);
                            setIsDownload(false);
                            setLinkAddSection(0);
                            return e;
                        });
                        linkRef.current.hide();
                    }}>Add</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500 }} className="w-100">
                    {linkAddSection == 0 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-15 f-col">
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                style={{borderBottom: '1px solid'}}
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(false);
                                }}>
                                <span>
                                    Create Web Link
                                </span>
                                <FontAwesomeIcon icon={faGlobe} className="add-icon" />
                            </a>
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(true);
                                }}>
                                <span>
                                    Create Download
                                </span>
                                <FontAwesomeIcon icon={faDownload} className="add-icon" />
                            </a>
                        </div>
                    )}
                    {linkAddSection == 1 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-10 f-row f-wrap">
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="w-100 text-sm">{isDownload ? "Download Title" : "Web Link Title"}</label>
                            <input id="link-text" type="text" className="w-100" value={newLinkText} onChange={(e) => setNewLinkText(e.target.value)} />
                            {!isDownload && (
                                <>
                                    <label style={{marginBottom: -5}} htmlFor="link-type" className="mt-20 w-100 text-sm">Link Type</label>
                                    <select id="link-type" type="text" className="w-100" value={linkType} onChange={(e) => setLinkType(parseInt(e.target.value))}>
                                        <option value={0}>Website</option>
                                        <option value={1}>Product</option>
                                        <option value={2}>Article</option>
                                    </select>
                                </>
                            )}
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="mt-20 w-100 text-sm">{isDownload ? "Upload File" : "Web Link URL"}</label>
                            {isDownload ? (
                                <input type="file" className="grow" value={downloadFP} onChange={(e) => {
                                    setDownloadFP(e.target.value);
                                    setDownloadFile(e.target.files[0]);
                                }} />
                            ) : (
                                <input id="link-url" type={"text"} className="grow" value={newLinkURL} onChange={(e) => setNewLinkURL(e.target.value)} />
                            )}
                        </div>
                    )}
                </div>
            </Dialog>

            <div className="container w-100">
                <div className="form speaker-form f-start">
                    <div className="w-100 mb-10" style={{fontSize: 22}}>
                        <b>My Media</b>
                    </div>

                    <div className="content-box">
                        <div className="content-body">
                            <div className="w-100 sm-w-100 p-rel gap-10 f-wrap f-row">
                                <div style={{ marginBottom: 0 }}>
                                    <label className="flex-label">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <g clip-path="url(#clip0_623_155)">
                                                <path d="M9.32812 7.57913L12.373 9.60907C12.4169 9.63828 12.4679 9.65503 12.5206 9.65755C12.5732 9.66007 12.6256 9.64826 12.6721 9.62337C12.7186 9.59849 12.7574 9.56146 12.7845 9.51623C12.8116 9.47101 12.826 9.41927 12.826 9.36655V4.58845C12.826 4.53716 12.8125 4.48678 12.7868 4.44238C12.7611 4.39799 12.7242 4.36116 12.6797 4.33561C12.6352 4.31006 12.5848 4.2967 12.5335 4.29688C12.4822 4.29705 12.4319 4.31075 12.3876 4.3366L9.32812 6.12169" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.16177 3.49609H2.33197C1.68803 3.49609 1.16602 4.01811 1.16602 4.66205V9.32589C1.16602 9.96983 1.68803 10.4918 2.33197 10.4918H8.16177C8.80571 10.4918 9.32772 9.96983 9.32772 9.32589V4.66205C9.32772 4.01811 8.80571 3.49609 8.16177 3.49609Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_623_155">
                                                    <rect width="13.9915" height="13.9915" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Videos
                                        <a role="button" className="flex-label-add" onClick={() => {
                                            addVideoRef.current.show();
                                        }}>
                                            + Add
                                        </a>
                                    </label>
                                </div>
                                {getStandardVideos().length ? (
                                    <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                        {/*<ModulePosition position={positions[2]} index="2" setPositions={setPositions} />*/}
                                        <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={getStandardVideos()}
                                            onOrderChange={(newList) => {
                                                setHost(h => {
                                                    var newH = {...h};
                                                    newH.videos = newList;
                                                    return newH;
                                                });
                                            }}
                                            itemClass="card-item"
                                            renderItem={(h, i) => (
                                                <>
                                                    <VideoCard video={h} onRemove={((vu) => {
                                                        var index = host.videos.findIndex(h => h.videoUrl == vu);
                                                        if (index < 0)
                                                            return;
                                                        setHost(_e => {
                                                            let e = { ..._e };
                                                            e.videos.splice(index, 1);
                                                            return e;
                                                        });
                                                    })} key={i} />
                                                </>
                                            )} endItem={
                                                <div className="card-item">
                                                    <button className="add-item" onClick={() => {
                                                        addVideoRef.current.show();
                                                    }}>
                                                        <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                        <span>Add Video</span>
                                                    </button>
                                                </div>
                                            } />
                                    </div>
                                ) : (
                                    <div className="w-100">
                                        <div className="w-100">
                                            <button className="add-item full-width" onClick={() => {
                                                addVideoRef.current.show();
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_155)">
                                                        <path d="M9.32812 7.57913L12.373 9.60907C12.4169 9.63828 12.4679 9.65503 12.5206 9.65755C12.5732 9.66007 12.6256 9.64826 12.6721 9.62337C12.7186 9.59849 12.7574 9.56146 12.7845 9.51623C12.8116 9.47101 12.826 9.41927 12.826 9.36655V4.58845C12.826 4.53716 12.8125 4.48678 12.7868 4.44238C12.7611 4.39799 12.7242 4.36116 12.6797 4.33561C12.6352 4.31006 12.5848 4.2967 12.5335 4.29688C12.4822 4.29705 12.4319 4.31075 12.3876 4.3366L9.32812 6.12169" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M8.16177 3.49609H2.33197C1.68803 3.49609 1.16602 4.01811 1.16602 4.66205V9.32589C1.16602 9.96983 1.68803 10.4918 2.33197 10.4918H8.16177C8.80571 10.4918 9.32772 9.96983 9.32772 9.32589V4.66205C9.32772 4.01811 8.80571 3.49609 8.16177 3.49609Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_155">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <span>No videos added yet</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                                
                                <div style={{ marginBottom: 0 }} className="section-divider">
                                    <label className="flex-label">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <g clip-path="url(#clip0_623_696)">
                                                <path d="M9.90981 1.16406H4.08002C3.43608 1.16406 2.91406 1.68608 2.91406 2.33002V11.6577C2.91406 12.3016 3.43608 12.8236 4.08002 12.8236H9.90981C10.5538 12.8236 11.0758 12.3016 11.0758 11.6577V2.33002C11.0758 1.68608 10.5538 1.16406 9.90981 1.16406Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6.99609 10.4922H7.00192" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_623_696">
                                                    <rect width="13.9915" height="13.9915" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Shorts
                                        <a role="button" className="flex-label-add" onClick={() => {
                                            addVideoRef.current.show();
                                        }}>
                                            + Add
                                        </a>
                                    </label>
                                </div>
                                {!!getShorts().length ? (
                                    <>
                                        <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                            {/*<ModulePosition position={positions[2]} index="2" setPositions={setPositions} />*/}
                                            <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={getShorts()}
                                                onOrderChange={(newList) => {
                                                    setHost(h => {
                                                        var newH = {...h};
                                                        newH.videos = newList;
                                                        return newH;
                                                    });
                                                }}
                                                itemClass="card-item-2"
                                                renderItem={(h, i) => (
                                                    <>
                                                        <VideoCard video={h} onRemove={((vu) => {
                                                            var index = host.videos.findIndex(h => h.videoUrl == vu);
                                                            if (index < 0)
                                                                return;
                                                            setHost(_e => {
                                                                let e = { ..._e };
                                                                e.videos.splice(index, 1);
                                                                return e;
                                                            });
                                                        })} key={i} />
                                                    </>
                                                )} endItem={
                                                    <div className="card-item card-item-2">
                                                        <button className="add-item" style={{height: '100%'}} onClick={() => {
                                                            addVideoRef.current.show();
                                                        }}>
                                                            <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                            <span>Add Short</span>
                                                        </button>
                                                    </div>
                                                } />
                                        </div>
                                    </>
                                ) : (
                                    <div className="w-100">
                                        <div className="w-100">
                                            <button className="add-item full-width" onClick={() => {
                                                addVideoRef.current.show();
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_696)">
                                                        <path d="M9.90981 1.16406H4.08002C3.43608 1.16406 2.91406 1.68608 2.91406 2.33002V11.6577C2.91406 12.3016 3.43608 12.8236 4.08002 12.8236H9.90981C10.5538 12.8236 11.0758 12.3016 11.0758 11.6577V2.33002C11.0758 1.68608 10.5538 1.16406 9.90981 1.16406Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M6.99609 10.4922H7.00192" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_696">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <span>No shorts added yet</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                                
                                <div style={{ marginBottom: 0 }} className="section-divider">
                                    <label className="flex-label">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path d="M11.0757 1.75H2.91401C2.27006 1.75 1.74805 2.27202 1.74805 2.91596V11.0777C1.74805 11.7216 2.27006 12.2436 2.91401 12.2436H11.0757C11.7197 12.2436 12.2417 11.7216 12.2417 11.0777V2.91596C12.2417 2.27202 11.7197 1.75 11.0757 1.75Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M5.24604 6.41395C5.88998 6.41395 6.41199 5.89193 6.41199 5.24799C6.41199 4.60405 5.88998 4.08203 5.24604 4.08203C4.6021 4.08203 4.08008 4.60405 4.08008 5.24799C4.08008 5.89193 4.6021 6.41395 5.24604 6.41395Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M12.2427 8.74592L10.4437 6.94685C10.225 6.72826 9.9285 6.60547 9.61933 6.60547C9.31016 6.60547 9.01365 6.72826 8.795 6.94685L3.49805 12.2438" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Images
                                        <a role="button" className="flex-label-add" onClick={() => {
                                            addImageRef.current.show();
                                        }}>
                                            + Add
                                        </a>
                                    </label>
                                </div>
                                {host.images?.length ? (
                                    <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                        {/*<ModulePosition position={positions[3]} index="3" setPositions={setPositions} />*/}
                                        <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={host.images ?? []}
                                            onOrderChange={(newList) => {
                                                setHost(h => {
                                                    var newH = {...h};
                                                    newH.images = newList;
                                                    return newH;
                                                });
                                            }}
                                            itemClass="card-item-2"
                                            renderItem={(h, i) => (
                                                <>
                                                    <ImageCard image={h} onRemove={((_id) => {
                                                        var index = host.images.findIndex(h => h.id == _id);
                                                        if (index < 0)
                                                            return;
                                                        setHost(_e => {
                                                            let e = { ..._e };
                                                            e.images.splice(index, 1);
                                                            return e;
                                                        });
                                                    })} key={i} />
                                                </>
                                            )} endItem={
                                                <div className="card-item card-item-2">
                                                    <button className="add-item add-item-2 aspect-1" onClick={() => {
                                                        addImageRef.current.show();
                                                    }}>
                                                        <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                        <span>Add Image</span>
                                                    </button>
                                                </div>
                                            } />
                                    </div>
                                ) : (
                                    <div className="w-100">
                                        <div className="w-100">
                                            <button className="add-item full-width" onClick={() => {
                                                addImageRef.current.show();
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                    <path d="M11.0757 1.75H2.91401C2.27006 1.75 1.74805 2.27202 1.74805 2.91596V11.0777C1.74805 11.7216 2.27006 12.2436 2.91401 12.2436H11.0757C11.7197 12.2436 12.2417 11.7216 12.2417 11.0777V2.91596C12.2417 2.27202 11.7197 1.75 11.0757 1.75Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M5.24604 6.41395C5.88998 6.41395 6.41199 5.89193 6.41199 5.24799C6.41199 4.60405 5.88998 4.08203 5.24604 4.08203C4.6021 4.08203 4.08008 4.60405 4.08008 5.24799C4.08008 5.89193 4.6021 6.41395 5.24604 6.41395Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12.2427 8.74592L10.4437 6.94685C10.225 6.72826 9.9285 6.60547 9.61933 6.60547C9.31016 6.60547 9.01365 6.72826 8.795 6.94685L3.49805 12.2438" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <span>No images added yet</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                                
                                <div style={{ marginBottom: 0 }} className="section-divider">
                                    <label className="flex-label">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <g clip-path="url(#clip0_623_220)">
                                                <path d="M5.24687 9.91182H4.08091C3.30783 9.91182 2.56642 9.60472 2.01977 9.05807C1.47312 8.51142 1.16602 7.77001 1.16602 6.99693C1.16602 6.22385 1.47312 5.48243 2.01977 4.93578C2.56642 4.38914 3.30783 4.08203 4.08091 4.08203H5.24687" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.74414 4.08203H9.9101C10.6832 4.08203 11.4246 4.38914 11.9712 4.93578C12.5179 5.48243 12.825 6.22385 12.825 6.99693C12.825 7.77001 12.5179 8.51142 11.9712 9.05807C11.4246 9.60472 10.6832 9.91182 9.9101 9.91182H8.74414" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M4.66406 6.99609H9.3279" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_623_220">
                                                    <rect width="13.9915" height="13.9915" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Web Links
                                        <a role="button" className="flex-label-add" onClick={() => {
                                            linkRef.current.show();
                                        }}>
                                            + Add
                                        </a>
                                    </label>
                                </div>
                                {host.links?.length ? (
                                    <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                    {/*<ModulePosition position={positions[4]} index="4" setPositions={setPositions} />*/}
                                    <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={host.links ?? []}
                                        onOrderChange={(newList) => {
                                            setHost(h => {
                                                var newH = {...h};
                                                newH.links = newList;
                                                return newH;
                                            });
                                        }}
                                        itemClass="card-item-4"
                                        renderItem={(h, i) => (
                                            <>
                                                <LinkCard link={h} onRemove={((v) => {
                                                    var index = host.links.findIndex(h => h.url == v.url && h.text == v.text);
                                                    if (index < 0)
                                                        return;
                                                    setHost(_e => {
                                                        let e = { ..._e };
                                                        e.links.splice(index, 1);
                                                        return e;
                                                    });
                                                })} key={i} />
                                            </>
                                        )} endItem={
                                            <div className="card-item card-item-4">
                                                <button className="add-item add-item-4" style={{flexDirection: 'row', minHeight: 55.2}} onClick={() => {
                                                    linkRef.current.show();
                                                }}>
                                                    <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                    <span>Add Link or Download</span>
                                                </button>
                                            </div>
                                        } />
                                </div>
                                ) : (
                                    <div className="w-100">
                                        <div className="w-100">
                                            <button className="add-item full-width" onClick={() => {
                                                linkRef.current.show();
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_220)">
                                                        <path d="M5.24687 9.91182H4.08091C3.30783 9.91182 2.56642 9.60472 2.01977 9.05807C1.47312 8.51142 1.16602 7.77001 1.16602 6.99693C1.16602 6.22385 1.47312 5.48243 2.01977 4.93578C2.56642 4.38914 3.30783 4.08203 4.08091 4.08203H5.24687" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M8.74414 4.08203H9.9101C10.6832 4.08203 11.4246 4.38914 11.9712 4.93578C12.5179 5.48243 12.825 6.22385 12.825 6.99693C12.825 7.77001 12.5179 8.51142 11.9712 9.05807C11.4246 9.60472 10.6832 9.91182 9.9101 9.91182H8.74414" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M4.66406 6.99609H9.3279" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_220">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <span>No links added yet</span>
                                            </button>
                                        </div>
                                    </div>
                                )}

                                <div className="section-divider f-end flex f-row">
                                    <button onClick={save} className="btn btn-green">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Host;